import type React from 'react';
import styles from './index.module.scss';

import { Loading } from '../Loading';

export const LoadingPage: React.FC = () => (
  <div className={styles.loadingPage}>
    <Loading />
  </div>
);
